import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1b2a5281&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1b2a5281&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2a5281",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b2a5281')) {
      api.createRecord('1b2a5281', component.options)
    } else {
      api.reload('1b2a5281', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1b2a5281&scoped=true", function () {
      api.rerender('1b2a5281', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/welfare/cardDetail/index.vue"
export default component.exports